import type { HawbReleaseBlocker } from "#/types/manifest";
import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ReleaseBadgeProps {
  releaseBlockers: HawbReleaseBlocker[];
}

/** "Ready for Release" (green) or "Cannot Be Released" (red), from the file's three flags. */
const ReleaseBadge = ({ releaseBlockers }: ReleaseBadgeProps) => {
  const { t } = useTranslation();
  const ready = releaseBlockers.length === 0;
  return (
    <Badge color={ready ? "green" : "red"} variant="light">
      {ready ? t("manifests.release.ready") : t("manifests.release.cannot")}
    </Badge>
  );
};

export default ReleaseBadge;
